import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Copyright from "../Components/Copyright";
import ModalView from "../Components/ModalView";
import { matchOptions } from "../utils/function";
import {
  getCompany,
  getDocumentReqStudent,
  getDocumentRequest,
  getInternshipRequest,
  getInternStudent,
} from "../api/crud";
import { internType } from "../data/interntype-data";
import { AvatarGroup } from "@mui/material";

const DocumentRequest = () => {
  const [documentRequested, setDocumentRequested] = useState("");
  const [barcodeInputValue, setBarcodeInputValue] = useState("");
  const getIdmUsername = window.localStorage.getItem("idm_username");
  // const getIdmUsername = 63050046;
  const getIdmName = window.localStorage.getItem("idm_name");
  const [isModalDocOpen, setIsModalDocOpen] = useState(false);

  const onHanleinitData = () => {
    setIsModalDocOpen(false);
  };

  // useEffect(() => {
  //   if (getIdmUsername) {
  //     setIsModalDocOpen(true);
  //   }
  // }, [getIdmUsername]);

  //   useEffect(() => {
  //     if (!isModalDocOpen && getIdmUsername) {
  //       window.localStorage.setItem("idm_username", "");
  //     }
  //   }, [isModalDocOpen]);

  function barcodeAutoFocus() {
    document.getElementById("SearchbyScanning").focus();
  }

  function onChangeBarcode(event) {
    console.log("onChangeBarcode", event);
    setBarcodeInputValue(event.target.value);
  }

  function onKeyPressBarcode(event) {
    if (event.keyCode === 13 && event.target.value.length >= 13) {
      const st_id = event.target.value.slice(5, 13);

      setBarcodeInputValue(st_id);
    }
  }

  const getData = async () => {
    const documentRequest = await getDocumentRequest();
    const internStudent = await getInternStudent();
    const allCompany = await getCompany();
    const internshipRequest = await getInternshipRequest();
    const docReqStudent = await getDocumentReqStudent();

    const studentDetail = internStudent.map((st) => {
      const find = internshipRequest.find((el) => el.st_id == st.id);

      return {
        ...st,
        internDetail: find,
      };
    });

    const companyWithStd = allCompany.map((company) => {
      const internSt = studentDetail.filter(
        (st) => st.internDetail?.cp_id == company.id
      );

      return {
        ...company,
        internStudent: internSt,
      };
    });

    const docReq = documentRequest.map((item) => {
      const findCompany = companyWithStd.find((cp) => cp.id == item.cp_id);

      return {
        ...item,
        companyDetail: findCompany,
      };
    });

    const filterByIdm = docReq.filter((res) => res.idm_status == 2);

    const filterByStd = filterByIdm.find((el) => {
      const ft = el.companyDetail.internStudent.find(
        (e) => e?.id == getIdmUsername
      );

      return ft?.id == getIdmUsername;
    });

    const docReqStudentByDoc = docReqStudent
      .filter((doc) => doc.idm_id === filterByStd.idm_doc_id)
      .map((el) => el.st_id);

    const matchStdWithIdm = filterByStd.companyDetail.internStudent.filter(
      (el) => docReqStudentByDoc.indexOf(el.id) !== -1
    );

    const newFilterByStd = {
      ...filterByStd,
      companyDetail: {
        ...filterByStd.companyDetail,
        internStudent: matchStdWithIdm,
      },
    };

    if (!newFilterByStd) {
      setIsModalDocOpen(false);
    } else {
      setIsModalDocOpen(true);
    }

    setDocumentRequested(newFilterByStd);
  };

  useEffect(() => {
    getData();
  }, []);

  console.log({ documentRequested });

  const modalContent = (
    <div className="p-4">
      <div className="">
        <h3>หนังสือขอความอนุเคราะห์ฝึกงาน</h3>
        <h5 className="badge bg-primary">{documentRequested?.idm_doc_id}</h5>
      </div>
      <form action="./update-status-get-document.php" method="post">
        <div
          className="card mb-3 bg-light mx-auto  border"
          style={{ width: "400px" }}
        >
          <div className="card-body p-3">
            <div className="">
              <div>เรียน {documentRequested?.idm_header}</div>
              <div className="">{documentRequested?.companyDetail?.name}</div>
              <small>
                {documentRequested?.companyDetail?.address} ต.
                {documentRequested?.companyDetail?.subdistrict} อ.
                {documentRequested?.companyDetail?.district} จ.
                {documentRequested?.companyDetail?.province}{" "}
                {documentRequested?.companyDetail?.zip}
              </small>
              <div className="">
                <span className="badge bg-secondary">
                  {matchOptions(internType, documentRequested?.type_intern)}
                </span>
              </div>
            </div>

            <div>
              <AvatarGroup
                total={documentRequested?.companyDetail?.internStudent?.length}
              >
                {documentRequested?.companyDetail?.internStudent?.length &&
                  documentRequested?.companyDetail?.internStudent?.map(
                    (st, stIndex) => {
                      return (
                        <Avatar
                          key={stIndex}
                          alt={st?.name}
                          sx={{ height: 50, width: 50 }}
                          src={`http://reg.buu.ac.th/registrar/getstudentimage.asp?id=${st?.id}`}
                        />
                      );
                    }
                  )}
              </AvatarGroup>
            </div>
          </div>
        </div>

        <div className="text-end">
          มารับโดย{" "}
          {
            documentRequested?.companyDetail?.internStudent?.find(
              (el) => el?.id == getIdmUsername
            )?.id
          }{" "}
          {
            documentRequested?.companyDetail?.internStudent?.find(
              (el) => el?.id == getIdmUsername
            )?.name
          }
        </div>
        <div className="text-end mt-2">
          <button
            className="btn btn-primary"
            type="submit"
            // onClick={onHanleinitData}
          >
            ยืนยัน
          </button>
        </div>

        <input
          name="req_id"
          value={documentRequested?.idm_doc_id}
          className="d-none"
        />
        <input name="user" value={getIdmUsername} className="d-none" />
        <input className="d-none" value={2} name="doc_type" />
        {documentRequested?.companyDetail?.internStudent?.length &&
          documentRequested?.companyDetail?.internStudent?.map((st) => {
            return <input name="st_id[]" value={st?.id} className="d-none" />;
          })}
        <input className="d-none" value={1} name="only_get_doc" />
      </form>
    </div>
  );

  return (
    <Container component="main" maxWidth="lg">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          justifyContent: "center",
          display: "flex",

          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src="./assets/images/logo_no_bg.png"
          alt="logo"
          width={400}
          className=" mb-5 mx-auto"
        />

        <Typography component="h1" variant="h5" color="blue">
          การรับหนังสือขอความอนุเคราะห์ฝึกงาน / สหกิจศึกษา
        </Typography>

        <input
          placeholder="โปรดสแกนบัตรนิสิต"
          autoFocus={true}
          value={barcodeInputValue}
          onChange={onChangeBarcode}
          id="SearchbyScanning"
          className="SearchInput form-control text-center"
          onKeyDown={onKeyPressBarcode}
          style={{ maxWidth: "400px", width: "100%" }}
          // onBlur={barcodeAutoFocus}
        />
        <br />
        <form
          action="./ldaptest2.php"
          method="post"
          style={{ maxWidth: "400px", width: "100%", marginTop: "20px" }}
        >
          <input
            className="d-none"
            name="name"
            value={barcodeInputValue}

            // onBlur={barcodeAutoFocus}
          />
          {barcodeInputValue.length === 8 && (
            <>
              <input
                type="password"
                name="pass"
                className="form-control text-center"
                placeholder="Password"
              />
              <br />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Sign In
              </Button>
            </>
          )}
        </form>
      </Box>
      <Copyright
        textColor="text.secondary"
        variant="body1"
        align="center"
        isShowOwner
      />
      <ModalView
        isModaOpen={isModalDocOpen}
        setIsModalOpen={setIsModalDocOpen}
        onClose={() => {
          window.localStorage.setItem("idm_username", "");
          setBarcodeInputValue("");
        }}
      >
        <div>
          {documentRequested ? modalContent : "ไม่พบหนังสือขอความอนุเคราะห์"}
        </div>
      </ModalView>
    </Container>
  );
};

export default DocumentRequest;
